"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp(target, key, result);
  return result;
};
var __async = (__this, __arguments, generator) => {
  return new Promise((resolve, reject) => {
    var fulfilled = (value) => {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    };
    var rejected = (value) => {
      try {
        step(generator.throw(value));
      } catch (e) {
        reject(e);
      }
    };
    var step = (x) => x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
    step((generator = generator.apply(__this, __arguments)).next());
  });
};
import { Component, Mixins, Ref } from "vue-property-decorator";
import UiDialog from "@/components/dialog/UiDialog.vue";
import API from "@ym-framework/api-utils";
import { AccountSessionMixins } from "@/service/account-session";
let Gift = class extends Mixins(AccountSessionMixins) {
  constructor() {
    super(...arguments);
    this.gift_flag = false;
    this.imgmodel = [];
  }
  created() {
    return __async(this, null, function* () {
    });
  }
  mounted() {
    return __async(this, null, function* () {
    });
  }
  checkDialog() {
    return __async(this, null, function* () {
      try {
        let response = yield API.get(`api://base.auth/api/v7/activity`);
        let item = response.data;
        if (item.model === "img.message.noshow") {
        }
        if (item.model === "img.message" && item.result.datas.length > 0) {
          for (let data of item.result.datas) {
            this.imgmodel.push(data);
            for (let mark of data.marks) {
              if (mark === "NOVICE_GUIDE") {
                this.gift_flag = true;
              }
            }
          }
        }
      } catch (error) {
        console.log(error);
        if (error.hasOwnProperty("response")) {
        }
      }
      if (this.imgmodel.length !== 0) {
        if (localStorage.getItem("gift_show") === null) {
          localStorage.setItem("gift_show", "true");
          this.opendialog();
        }
      }
      this.$root.$on("imgMessage", (data) => __async(this, null, function* () {
        this.imgmodel = data.result.datas;
        this.opendialog();
      }));
    });
  }
  opendialog() {
    this.gift_dialog.show();
  }
  openhtml(data) {
    return __async(this, null, function* () {
      var _a;
      if (data.search("local:") !== -1) {
        let arr = data.split(":");
        if (arr[1].indexOf("payment") !== -1) {
          if (this.$session.type === "account" || this.$session.type === "user" && ((_a = this.$session) == null ? void 0 : _a.permissions.any("VD_NEW", "SHOW_ALL_MENUS"))) {
            this.$router.push(`/${arr[1]}`);
          } else {
          }
          return;
        }
        if (arr[1].indexOf("payment") === -1) {
          this.$router.push(`/${arr[1]}`);
          return;
        }
      }
      window.open(data, "_blank");
    });
  }
  closegift() {
    this.$emit("closegift");
  }
  closegiftnow() {
    return __async(this, null, function* () {
      if (this.gift_flag === true) {
        yield API.put(`api://base.auth/api/v5/account/close/novice`);
      }
      this.$emit("closegift");
      this.gift_dialog.hide();
    });
  }
};
__decorateClass([
  Ref("gift-img-dialog")
], Gift.prototype, "gift_dialog", 2);
Gift = __decorateClass([
  Component({
    components: {
      UiDialog
    }
  })
], Gift);
export {
  Gift as default
};
